import React, { useState } from 'react';
import CreateGestanteForm from '../../components/Forms/CreateGestanteForm';
import api from '../../services/api';

const GestanteCreatePage = () => {
  const [formData, setFormData] = useState({
    nome: "",
    cpf: "",
    cns: "",
    municipio: ""
  });

  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      const sanitizedCpf = formData.cpf.replace(/[.-]/g, '');
      const sanitizedData = {
        ...formData,
        cpf: sanitizedCpf
      };

      await api.post('/gestante/create', sanitizedData);
      alert('Gestante cadastrada com sucesso!');
      window.location.href = '/gestante';
    } catch (error) {
      const errorDetail = error.response?.data?.detail || 'Erro desconhecido';
      setErrorMessage(`Erro ao cadastrar a gestante: ${errorDetail}`);
    }
  };

  return (
    <div>
      {errorMessage && <p style={{ color: '#1a1a1a' }}>{errorMessage}</p>}

      <CreateGestanteForm
        formData={formData}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default GestanteCreatePage;
